var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '../elements/index';
const InfoButton = props => {
    const { className, small } = props, rest = __rest(props, ["className", "small"]);
    return (React.createElement(Button, Object.assign({ className: classnames('InfoButton', className, {
            'InfoButton--small': small
        }) }, rest)));
};
export default InfoButton;
